import Settings from './containers/Settings';
import pageLayoutHoc from '../../hocs/pageLayoutHoc';
export const settingsRoutes = [
  {
    path: '/settings',
    component: pageLayoutHoc(Settings),
    key: 'settings',
  },
];
